export default __webpack_public_path__ + "static/media/tooltip-icon.dd2b880b.svg";